import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Desabilita error overlay do React (remove popup vermelho de erro)
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (/WebSocket/.test(args[0])) {
      return; // Ignora erros de WebSocket
    }
    originalError.call(console, ...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
